export class AssignedRole {
  role_id: string;

  group_id: string;
}
